<div id="auth-box" class="box">

  <h1>
    {{'Authorization succeeded' | translate}}
  </h1>

</div>